// extracted by mini-css-extract-plugin
export default {"holderArea":"Holder_holderArea__SzbeS"};